import { ColumnDef } from "@tanstack/react-table";
import { displayCountOrDash } from "@/core/utils/number";
import { ISpiff } from "@/spiffs/spiffs.d";

interface WithSpiffs {
  spiffs: ISpiff[];
}

const DismissedCol = <T extends WithSpiffs>(): ColumnDef<T> => ({
  header: "Dismissed",
  accessorFn: (row) =>
    row.spiffs.filter((spiff) => !!spiff.dismissed_at).length,
  cell: ({ getValue }) => displayCountOrDash(getValue() as number),
});

export default DismissedCol;
